import styled from "styled-components";

export const GradeStyled = styled.main`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  display: flex;
  margin: auto 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  /* background-color: blueviolet; */

  .IconAlerte {
    display: flex;
    align-items: center;
    position: absolute;
    top: 78px;
    right: 15%;
    button {
      font-size: 40px;
      cursor: pointer;
      padding: 0;
      background-color: transparent;
      border: none;
      z-index: 3;
    }
    .iconStyledAlert {
      color: rgba(118, 118, 118, 1);
      transition: 0.5s;
    }
    .iconStyledAlert:hover {
      color: rgb(34, 34, 34);
    }
    .iconStyledAlertPorcesso {
      color: rgb(224, 169, 3);
      filter: drop-shadow(0px 0px 5px rgba(251, 255, 4, 0.45));

      animation: alertAnim 2s ease infinite;
    }
    .iconStyledAlertEmegencia {
      color: rgb(224, 3, 3);
      filter: drop-shadow(0px 0px 5px rgba(252, 0, 0, 0.45));
      animation: alertAnim 1s ease infinite;
    }
  }

  .GradeUl {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: start;
    text-align: center;
    flex-direction: column;
    width: 85%;
    max-width: 100%;
    min-height: 80vh;
    margin-top: 70px;
    list-style: none;
    margin-bottom: 50px;
    @media (min-width: 1500px) {
      width: 80%;
    }
    .LiTeste {
      width: 100px;
      height: 100px;
    }
    .GradeLi {
      display: flex;
      align-items: center;
      gap: 10px;
      /* flex-direction: column; */
      padding-top: 60px;
      width: 100%;
      /* background-color: aqua; */
      @media (max-width: 1450px) {
        flex-direction: column;
      }
      .tituloPoco {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 30%;
        background: var(--cor-primaria);
        box-shadow: 2px 2px 10px var(--shadow);
        color: var(--branco);
        border-radius: 0 25px 25px 0;
        gap: 5px;
        position: absolute;
        top: 80px;
        left: 0;
        .iconBack {
          font-size: 30px;
          cursor: pointer;
        }
        .tituloStatus {
          h3,
          h2 {
            font-size: 20px;
          }
          display: flex;
          gap: 15px;
          .statusPoco {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            gap: 5px;

            .statusDisplay {
              width: 20px;
              height: 20px;
              border-radius: 50%;
            }
            .StatusOFF {
              background-color: var(--offline);
              border: 1px solid var(--branco);
            }
            .StatusOn {
              background-color: var(--online);
              border: 1px solid var(--branco);
            }
            p {
              font-size: 20px;
            }
          }
        }
        @media screen and (max-width: 800px) {
          width: 70%;
          .tituloStatus {
            h3,
            h2 {
              font-size: 18px;
            }
          }
          .statusPoco {
            p {
              display: none;
            }
          }
        }
      }
      .conteinerGradeInfo {
        display: flex;
        gap: 15px;

        .GradeInfo {
          display: flex;
          flex-direction: column;
          position: relative;
          width: 650px;
          align-items: flex-start;
          gap: 10px;
          /* background-color: aqua; */
          position: relative;
          .StatusAutomatico {
            display: flex;
            justify-content: center;
            align-items: center;
            /* width: 60px; */
            padding: 5px 8px;
            /* height: 25px; */
            position: absolute;
            top: 10px;
            left: 0;
            border-radius: 10px;
            border: 1px solid var(--cor-primaria);
            color: white;
            background-color: rgb(27, 110, 233);
            font-size: 13px;
          }
          .StatusAutomaticoManual {
            background-color: rgb(31, 126, 18);
            border: 1px solid rgb(31, 126, 18);
          }
          @media (max-width: 850px) {
            width: 100%;
          }
          /* @media (max-width: 850px) {
            width: 100%;
          } */
          .statusGrade {
            z-index: 2;
            display: flex;
            justify-content: flex-start;
            /* width: 70%; */
            .imgGrade {
              width: 65%;
              /* background-color: blueviolet; */
              @media (max-width: 850px) {
                width: 85%;
              }
            }
          }
          .statusGradeUl {
            list-style: none;
            display: flex;
            width: 100%;
            justify-content: space-around;
            li {
              display: flex;
              flex-direction: column;
              gap: 2px;
              align-items: center;
              div {
                width: 90px;
                height: 20px;
                background-color: rgba(77, 77, 77, 0.32);
                border-radius: 5px;
                border: 1px solid rgb(77, 77, 77);
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
              }
              .gradeOn {
                background-color: rgb(53, 191, 25);
              }
              span {
                /* font-size: 20px; */
                font-weight: 600;
              }
            }
            @media (max-width: 850px) {
              li {
                span {
                  font-size: 12px;
                  font-weight: 600;
                }
                div {
                  width: 50px;
                  font-size: 10px;
                }
              }
              /* flex-direction: column; */
              /* background-color: aqua; */
              /* width: 100px; */
            }
          }
          .TrasporteInfo {
            display: flex;
            z-index: 1;
            position: absolute;
            left: 255px;
            bottom: 130px;
            max-width: 100%;
            @media (max-width: 850px) {
              display: none;
            }

            .imgTrasporte {
              img {
                width: 78%;
              }
            }
          }
        }

        .nivelReal {
          display: flex;
          align-items: center;
          gap: 5px;
          position: relative;
          width: 150px;
          /* height: 100%; */
        }
      }
      .infoPocoGrafico {
        display: flex;
        gap: 15px;
        max-width: 100%;
        .blocoTabelaGrafico {
          display: flex;
          flex: 1 1 0; /* cresce para ocupar todo o resto */
          min-width: 450px; /* só quebra quando não tiver 250px disponíveis */
          flex-direction: column;
          gap: 20px;
          max-width: 100%;

          @media (min-width: 1000px) {
            min-height: 410px;
          }
          @media (max-width: 660px) {
            min-width: 300px;
            max-width: 100%;
            height: 550px;
          }
          @media (max-width: 1390px) {
            max-width: 720px;
          }
          .blocoTabelaConteiner {
            display: flex;
            align-items: end;
            gap: 10px;

            @media (max-width: 660px) {
              flex-direction: column;
            }
            .blocoTabela {
              background-color: var(--branco);
              max-width: 100%;
              height: 120px;
              max-height: 100%;
              border: 3px solid var(--cor-primaria);
              box-shadow: 2px 2px 10px var(--shadow);
              border-radius: 10px;
              display: flex;
              align-items: start;
              justify-content: center;
              overflow-y: auto;
              @media (max-width: 660px) {
                height: 200px;
              }

              .tabela {
                background-color: var(--branco);
                width: fit-content;
                max-width: 100%;
                border-collapse: collapse;
                text-align: center;
                flex-direction: column;

                tbody {
                  tr {
                    width: 100%;
                  }
                  .mensagemTr {
                    white-space: nowrap; /* Impede que o texto quebre linha */
                    overflow: hidden; /* Oculta o conteúdo excedente */
                    text-overflow: ellipsis; /* Adiciona "..." no final */
                    max-width: 100px; /* Define um tamanho máximo para truncar o texto */
                  }
                }
                td {
                  width: 400px;
                  max-width: 100%;
                  border: 1px solid #aaaaaa;
                  padding: 3px 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: var(--cor-contraste);
                }
                thead {
                  background: var(--degrade);
                  border: 1px solid red;
                }
                th {
                  padding: 3px 5px;
                  font-size: 15px;
                  color: var(--branco);
                }
              }
            }

            .blocoTabela::-webkit-scrollbar {
              width: 2px;
              height: 2px;
            }

            .blocoTabela::-webkit-scrollbar-thumb {
              background: var(--cor-primaria);
              border-radius: 10px;
            }
            .botaoTabela {
              display: flex;
              flex-direction: column;
              height: 100%;
              justify-content: space-around;
              align-items: center;
              /* gap: 5px; */
              @media (max-width: 660px) {
                flex-direction: row;
                width: 100%;
                height: 60px;
              }
              button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 150px;
                height: 40px;
                max-width: 100%;
                font-size: 18px;
                transition: 0.5s;
                background: var(--branco);
                border-radius: 3px;
                cursor: pointer;
                color: var(--cor-primaria);
                font-weight: 600;
                border: 2px solid var(--cor-primaria);
                @media (max-width: 660px) {
                  width: 140px;
                  font-size: 16px;
                }
              }
              button:hover {
                background: var(--degrade);
                color: var(--branco);
                border: 2px solid var(--cor-primaria);
                box-shadow: 2px 2px 10px var(--shadow);
              }
            }
          }
        }
        .BlocoInfoPoco {
          display: none;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          border: 2px solid var(--cor-primaria);
          box-shadow: 2px 2px 10px var(--shadow);
          border-radius: 10px;
          height: 435px;
          width: 350px;

          @media (max-width: 730px) {
            width: 83%;
            height: 500px;
          }
          h3 {
            margin: 15px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--branco);
            background: var(--degrade);
            width: 100%;
            max-width: 100%;
            height: 30px;
            padding: 3px;
          }

          .dadosInfoPoco {
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: end;
            gap: 20px;
          }

          .dadosPoco {
            display: flex;
            flex-direction: column;
            align-items: end;
            max-width: 100%;
            text-align: right;
            color: var(--cor-contraste);

            .cxInfoPoco {
              width: 75px;
              max-width: 100%;
              height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: var(--cor-contraste);
              font-size: 15px;
              background-color: var(--branco);
              border: 2px solid var(--cor-contraste);
              border-radius: 3px;
              font-weight: 600;
            }
          }

          .blocoControle {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            color: var(--cor-contraste);
            position: relative;

            .controle {
              display: flex;
              width: 100%;
              justify-content: center;
              align-items: center;
              gap: 12px;
              margin-top: 22px;
              padding: 18px;
              flex-wrap: wrap;
              .divControler {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 5px;
              }

              h3 {
                position: absolute;
                color: var(--branco);
                top: -20px;
                background: var(--degrade);
                width: 100%;
                text-align: center;
                height: 30px;
              }
              p {
                width: 80px;
                font-weight: 600;
              }
              .cxControle {
                padding: 15px;
                width: 40px;
                max-width: 100%;
                height: 30px;
                border-radius: 3px;
                border: 2px solid var(--cor-contraste);
                background-color: var(--branco);
              }
            }
          }
        }
      }
    }
  }
`;

export const ContainerNivelGrade = styled.div`
  width: 40px;
  height: ${({ altura }) => altura || "100%"};
  border: 2px solid #ccc;
  background-color: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  @media (max-width: 850px) {
    width: 30px;
  }
`;

export const GradeNivel = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgb(37, 162, 246);
  height: ${({ porcentagem }) => `${Math.max(0, Math.min(porcentagem, 100))}%`};
  transition: height 0.8s ease;
`;

export const MarcadoresNivel = styled.div`
  display: flex;
  position: absolute;
  justify-content: flex-start;
  left: 25px;
  bottom: ${({ altura }) => `${altura}%` || "0"};
  font-size: 15px;
  /* background-color: rgba(0, 0, 0, 0.7); */
  width: 140px;

  @media (max-width: 850px) {
    font-size: 12px;
    z-index: 5;
  }
`;

export const TextoVertical = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  margin-top: 8px;
  color: #333;
  @media (max-width: 850px) {
    font-size: 15px;
  }
`;

export const TextoVertical1 = styled.h3`
  writing-mode: vertical-rl;
  transform: rotate(180deg); // Deixa texto de cima pra baixo
  margin: 0;
  font-size: 18px;
  color: #333;
`;
